/**
 * Configuration for Raven.js
 */
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

import Rover from '@rover/globals/Rover';
import settings from '@rover/globals/settings';
import currentUser from '@rover/globals/currentUser';

window.Raven = Raven;

function init() {
  window.Raven.config(settings.SENTRY_DSN)
    .addPlugin(RavenVue, Vue)
    .install();

  currentUser
    .waitForAuthenticatedUserLoaded()
    .then(user => {
      window.Raven.setUser({
        id: user.id,
      });
    })
    .catch(() => {});
}

init();



// WEBPACK FOOTER //
// ../utilities/ravenConfig.js